import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
  HttpClientModule ,
   HTTP_INTERCEPTORS ,
   HttpClientXsrfModule
} from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

@Injectable()
export class LanguageIntercepter implements HttpInterceptor {
  intercept(
    requset: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const lang = localStorage.getItem('lang') || 'en';

    requset = requset.clone({
      setHeaders: {
        'Accept-Language': lang,
      },
    });
    return next.handle(requset);
  }
}